export default __webpack_public_path__ + "static/media/weather_00.032ac677.png";